import { render, staticRenderFns } from "./ListagemPedidos.vue?vue&type=template&id=2add24cf&scoped=true"
import script from "./ListagemPedidos.vue?vue&type=script&lang=js"
export * from "./ListagemPedidos.vue?vue&type=script&lang=js"
import style0 from "./ListagemPedidos.vue?vue&type=style&index=0&id=2add24cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add24cf",
  null
  
)

export default component.exports